// extracted by mini-css-extract-plugin
module.exports = {"themeGraphic":"speakers-sa-2024_themeGraphic__ksprH","avatar":"speakers-sa-2024_avatar__dDxWo"};